<div *ngIf="showCustomers" style="background-color:bisque">
  <p-selectButton [options]="customers" [(ngModel)]="userService.customer" optionLabel="description" optionValue="id"
    (onChange)="showReport()" />
</div>
<hr *ngIf="showCustomers" style="width:100%; height: 1px;margin:0px">

<div *ngIf="userService.customer && isBusy" class="progress-spinner">
  <p-progressSpinner ariaLabel="Loading" />
</div>

<div class="grid" *ngIf="userService.customer" style="background-color:lavender">

  <p class="col-3" style="text-align: right;"><b>{{customerName}} Overall</b></p>
  <p-chart class="col-8" type="bar" [data]="custChartData" width="90" [options]="customerChartOptions" />
  <div class="col-1"></div>

  <hr style="width:100%; height: 1px;margin:0px">

  <div class="col-3" style="min-width:254px;align-content:center;">
    <div style="margin-bottom:10px;text-align:center;"><b>{{screenTransLabel}}</b></div>
    <p-chart type="doughnut" [data]="screenChartData" width="125" [options]="doughtnutChartOptions"
      [plugins]="doughtnutChartCenterText" />

    <div class="col-12"></div>
    <div class="grid">
      <p-chart class="col-4" type="doughnut" [data]="screenPLTeamChartData" width="130" [options]="plTeamChartOptions"
        [plugins]="doughtnutChartCenterText" />
      <p-chart class="col-4" type="doughnut" [data]="screenCustChartData" width="130" [options]="uatTeamChartOptions"
        [plugins]="doughtnutChartCenterText" />
      <p-chart class="col-4" type="doughnut" [data]="screenPIChartData" width="130" [options]="piTeamChartOptions"
        [plugins]="doughtnutChartCenterText" />
    </div>
  </div>

  <div class="col-9">
    <p-treeTable [value]="screenData" [columns]="cols">
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th style="width:250px;padding:.5em"></th>
          <th *ngFor="let col of columns" style="width:85px; text-align:end;padding:.5em">
            {{ col.header }}
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowNode let-rowData="rowData" let-columns="columns">
        <tr [ttRow]="rowNode">
          <td style="padding:0em">
            <p-treeTableToggler [rowNode]="rowNode" />
            <ng-container>
              {{ rowData.label }}
              <p-chart type="bar" *ngIf="!rowNode.node.leaf && rowData.Totals.chartData" width="5"
                [data]="rowData.Totals.chartData" [options]="treeItemsChartOptions"
                style="display:flex;height:20px" />
            </ng-container>
          </td>
          <td *ngFor="let col of columns; let i = index" style="text-align:end;padding:.5em;">
            <div title="Count: {{rowData[col.field].count}}">
              <div *ngIf="rowNode.node.leaf" (click)="showScreenDetails(rowNode, col.field)"> {{
                rowData[col.field].count||"-" }} </div>
              <div *ngIf="!rowNode.node.leaf && !rowData[col.field].count">-</div>
              <div *ngIf="!rowNode.node.leaf && rowData[col.field].count">
                {{ rowData[col.field].complete | number: '1.0-1'}} %
              </div>
            </div>
          </td>
        </tr>
      </ng-template>

    </p-treeTable>
  </div>

  <hr style="width:100%; height: 1px;margin:0px">

  <div class="col-3" style="min-width:254px;align-content:center;">
    <div style="margin-bottom:10px;text-align:center;"><b>{{programTransLabel}}</b></div>
    <p-chart type="doughnut" [data]="programChartData" width="125" [options]="doughtnutChartOptions"
      [plugins]="doughtnutChartCenterText" />

    <div class="col-12"></div>
    <div class="grid">
      <p-chart class="col-4" type="doughnut" [data]="programPLTeamChartData" width="110" [options]="plTeamChartOptions"
        [plugins]="doughtnutChartCenterText" />
      <p-chart class="col-4" type="doughnut" [data]="programCustChartData" width="110" [options]="uatTeamChartOptions"
        [plugins]="doughtnutChartCenterText" />
      <p-chart class="col-4" type="doughnut" [data]="programPIChartData" width="110" [options]="piTeamChartOptions"
        [plugins]="doughtnutChartCenterText" />
    </div>
  </div>

  <div class="col-9">
    <p-treeTable [value]="programData" [columns]="cols">
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th style="width:250px;padding:.5em"></th>
          <th *ngFor="let col of columns" style="width:85px; text-align:end;padding:.5em">
            {{ col.header }}
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowNode let-rowData="rowData" let-columns="columns">
        <tr [ttRow]="rowNode">
          <td style="padding:0em">
            <p-treeTableToggler [rowNode]="rowNode" />
            {{ rowData.label }}
            <p-chart type="bar" *ngIf="!rowNode.node.leaf && rowData.Totals.chartData" width="50"
              [data]="rowData.Totals.chartData" [options]="treeItemsChartOptions"
              style="display:flex;height:20px" />
          </td>
          <td *ngFor="let col of columns; let i = index" style="text-align:end;padding:.5em">
            <div title="Count: {{rowData[col.field].count}}">
              <span *ngIf="rowNode.node.leaf"> {{ rowData[col.field].count||"-" }} </span>
              <span *ngIf="!rowNode.node.leaf && !rowData[col.field].count">-</span>
              <span *ngIf="!rowNode.node.leaf && rowData[col.field].count">
                {{ rowData[col.field].complete | number: '1.0-1'}} %
              </span>
            </div>
          </td>
        </tr>
      </ng-template>

    </p-treeTable>
  </div>

  <hr style="width:100%; height: 1px;margin:0px">
</div>